/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type SwitchDirectiveCb = () => SwitchDirective;
    
    /**
     * Custom scope
     */
    export interface ISwitchScopeDef {
        model: string;
        change: string;
        on: string;
        off: string;
    }
    
    /**
     * Custom scope
     */
    export interface ISwitchScope extends ng.IScope {
        model: boolean;
        change: () => void;
        on: string;
        off: string;
        saveChange(): void;
    }
    
    export class SwitchDirective implements ng.IDirective {
        public static $name: string = "switch";
        public static $inject: string[] = [];
        
        public link: (scope: ISwitchScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/switch-directive.html';
        public scope: ISwitchScopeDef = {
            model: '=',
            change: '&',
            on: '@',
            off: '@',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): SwitchDirectiveCb {
            let directive: SwitchDirectiveCb = () => {
                return new SwitchDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            SwitchDirective.prototype.link = (scope: ISwitchScope, element: JQuery, attrs: ng.IAttributes) => {
                scope.$watch('model', (newValue: boolean, oldValue: boolean) => {
                    if (scope.change && newValue !== oldValue) {
                        scope.change();
                    }
                });
            };
        }
    }
}